// extracted by mini-css-extract-plugin
export default {"inspirationFullView":"InspirationFullViewMany_inspirationFullView__yr6EE","inspiration":"InspirationFullViewMany_inspiration__M1dOT"};